module.exports = __webpack_public_path__ + "static/sport/bgi-form-h5.91ae6e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-form-h5.png
// module id = SYsE
// module chunks = 0